import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_TAGS } from '@/graphql/trainerTag';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import store from '@/store';

import logger from '@/modules/Logger';

export const GetTagOptionListService = {
  msb: async () => {
    logger.debug(`[Trainer Tag] Get Tag Option List using MSB GraphQL endpoint`, {
      operation: 'trainertag:option'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.query({ query: GET_TAGS });

    store.commit('trainerTag/setTagItems', data?.getTags);
  },

  legacy: async () => {
    logger.debug(`[Trainer Tag] Get Tag Option List using legacy endpoint`, {
      operation: 'trainertag:option'
    });

    await bizmatesWordbookApi.get('tags', {}, (response) => {
      store.commit('trainerTag/setTagItems', response.data.data);
    });
  }
};
